import MarkerClusterGroup from "@changey/react-leaflet-markercluster";
import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

const ZOOM_FOR_ICON_CHANGE = 9;
const ZOOM_FOR_ICON_SHOW = 6;

const RoadRestrictions = React.memo(
    ({ points, zoom, filters }) => {
        if (zoom <= ZOOM_FOR_ICON_SHOW) {
            return null;
        }
        return Object.entries(points).map(([groupId, items]) => {
            if (!(filters[groupId] ?? true)) {
                return null;
            }
            const iconProps =
                zoom > ZOOM_FOR_ICON_CHANGE
                    ? {
                          html: `<img src="${items[0].type.iconUrl}" />`,
                          className: "",
                          iconSize: [20, 20],
                      }
                    : { className: "map-icon--road-restriction-dot", iconSize: [8, 8] };

            const icon = divIcon(iconProps);
            return items.map((el, index) => <RoadRestriction key={index} icon={icon} item={el} />);
        });
    },
    (prevProps, nextProps) => {
        if (
            (prevProps.zoom > 9 && nextProps.zoom <= 9) ||
            (prevProps.zoom <= 9 && nextProps.zoom > 9) ||
            (prevProps.zoom > 6 && nextProps.zoom <= 6) ||
            (prevProps.zoom <= 6 && nextProps.zoom > 6) ||
            prevProps.filters !== nextProps.filters
        ) {
            return false;
        }
        return true;
    },
);

const RoadRestriction = (props) => {
    const {
        item: { location, name, description, type },
        icon,
    } = props;
    if (!location) {
        return null;
    }
    return (
        <Marker position={[...location].reverse()} icon={icon}>
            <Tooltip
                className="map__tooltip-road-restrictions leaflet-tooltip--left-align leaflet-tooltip--light"
                direction="top"
            >
                <div className="font-weight-bold">{type.name}</div>
                <div>{name}</div>
                <div className="small">{description}</div>
            </Tooltip>
        </Marker>
    );
};

const MemoizedRoadRestrictions = (props) => (
    <MarkerClusterGroup chunkedLoading disableClusteringAtZoom={6}>
        <RoadRestrictions {...props} />
    </MarkerClusterGroup>
);

export default MemoizedRoadRestrictions;
